import { useEffect, useState } from 'react';
import * as api from '../api';

// The signed-in person's own profile photo (from their HR employee record) as an object URL, for
// the top-bar and sidebar avatars. Fetched once per user and shared by every caller; null when
// there is no photo, so callers fall back to initials. HR photo uploads/removals fire
// MY_PHOTO_CHANGED, which drops the cache and fetches again.
export const MY_PHOTO_CHANGED = 'my-photo-changed';

let cache = { userId: null, promise: null };

const load = (userId) => {
  if (cache.userId !== userId || !cache.promise) {
    cache = {
      userId,
      promise: api.getMyPhoto().then(b => (b && b.size ? URL.createObjectURL(b) : null)).catch(() => null),
    };
  }
  return cache.promise;
};

export default function useMyPhoto(user) {
  const userId = user?.user_id || user?.id || null;
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!userId) { setUrl(null); return undefined; }
    let alive = true;
    const refresh = () => load(userId).then(u => { if (alive) setUrl(u); });
    refresh();
    const onChange = () => {
      cache.promise?.then(u => u && URL.revokeObjectURL(u));
      cache = { userId: null, promise: null };
      refresh();
    };
    window.addEventListener(MY_PHOTO_CHANGED, onChange);
    return () => { alive = false; window.removeEventListener(MY_PHOTO_CHANGED, onChange); };
  }, [userId]);

  return url;
}
